import React from "react";
import mariaHome from "../assets/maria_home.webp";
import { Helmet } from "react-helmet-async";

const HeroSection: React.FC = () => {
  return (
    <div>
      <Helmet>
        <title>RIAMA - Il tuo personale spazio di benessere</title>
        <meta property="og:type" content="website" />
        <meta name="description" content="Tramite lo zen shiatsu, il massaggio Thailandese ed altri rimedi olistici, do supporto a chi vuole ritrovare uno stato psicofisico ed un benessere ottimale e più in linea con il proprio personale ritmo e le proprie necessità." />
        <meta property="og:site_name" content="RIAMA - Il tuo personale spazio di benessere" />
        <meta property="og:url" content="https://riamaolistica.it/" />
        <meta property="og:title" content="RIAMA - Il tuo personale spazio di benessere" />
        <meta property="og:description" content="Tramite lo zen shiatsu, il massaggio Thailandese ed altri rimedi olistici, do supporto a chi vuole ritrovare uno stato psicofisico ed un benessere ottimale e più in linea con il proprio personale ritmo e le proprie necessità." />
        <meta property="og:image:jpeg" content="https://riamaolistica.it/maria_home.webp" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="RIAMA - Il tuo personale spazio di benessere" />
        <meta name="twitter:description" content="Tramite lo zen shiatsu, il massaggio Thailandese ed altri rimedi olistici, do supporto a chi vuole ritrovare uno stato psicofisico ed un benessere ottimale e più in linea con il proprio personale ritmo e le proprie necessità." />
      </Helmet>
      <section className="hero bg-riama-white py-16">
        <div className="container mx-auto flex flex-col lg:flex-row items-center">
          {/* Colonna sinistra: Titolo e sottotitolo */}
          <div className="text-center lg:text-left lg:w-1/2 px-4">
            <h1 className="text-4xl font-bold text-riama-blue leading-snug mb-6">
              UN APPROCCIO OLISTICO PER RITROVARE ARMONIA TRA CORPO, MENTE E SPIRITO.
            </h1>
            <p className="mt-4 text-4xl font-bold text-riama-blue leading-snug mb-4">
              UN INVITO A RALLENTARE, A RIDARE ASCOLTO AL CORPO NEL RISPETTO DEI SUOI RITMI NATURALI E DELLA SUA PIÙ
              SPONTANEA ESPRESSIONE.
            </p>
            <p className="text-2xl font-bold text-riama-red">- RIAMA</p>
          </div>

          {/* Colonna destra: Immagine */}
          <div className="lg:w-1/2 mt-8 lg:mt-0 px-4">
            <img
              src={mariaHome}
              alt="Maria Home"
              className="rounded-lg shadow-lg mx-auto lg:ml-8 w-full max-w-md"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeroSection;
